import { inject, injectable } from 'tsyringe';
import { type IBuyerUserTokenRepository } from 'application/repositorySchemas/IBuyerUserTokenRepository';
import { type ISurveyForBuyerRepository } from 'application/repositorySchemas/ISurveyForBuyerRepository';
import { type IAnswerSurveyForBuyerClient } from 'interfaceAdapter/gatewaySchemas/IAnswerSurveyForBuyerClient';

@injectable()
export class SurveyForBuyerRepository implements ISurveyForBuyerRepository {
    constructor(
        @inject('IBuyerUserTokenRepository')
        public readonly buyerUserToken: IBuyerUserTokenRepository,
        @inject('IAnswerSurveyForBuyerClient')
        public readonly answerSurveyClient: IAnswerSurveyForBuyerClient,
    ) {}

    public async answer(matchId: number, answers: Array<number | string | null>) {
        const { data, message } = await this.answerSurveyClient.post({
            token: this.buyerUserToken.get() || '',
            matchId,
            answers,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }
}
